import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import ScreenAndStyle from '../_utils/screen-and-style';
import Thumbnails from './thumbnails/thumbnails';
import MobileLoaderFooter from './mobile-loader-footer';
import DesktopLoaderFooter from './desktop-loader-footer';

function LoaderFooter({
  files,
  onAddImages,
  onErrorIconClick,
  onImagePreviewError,
  onRemoveThumbnail,
  brokenPreviews,
  onCancelClick,
}) {
  const [addPhotosDisabled, setAddPhotosDisabled] = useState(false);
  const handleAddPhotosClick = useCallback(() => {
    setAddPhotosDisabled(true);
    onAddImages();
    setTimeout(() => setAddPhotosDisabled(false), 2000);
  }, [onAddImages]);
  const isMobile =
    ScreenAndStyle.isBootstrapXS() || ScreenAndStyle.isBootstrapSM();
  const footerProps = {
    files,
    brokenPreviews,
    addPhotosDisabled,
    handleAddPhotosClick,
    onCancelClick,
    onErrorIconClick,
  };

  return (
    <div className="modal-footer d-flex flex-wrap rounded-0 my-2">
      <div className="w-100 thumbnails-mini">
        {files.length > 0 && (
          <Thumbnails
            classes="d-md-none d-lg-flex"
            files={files}
            withOrientation={true}
            onErrorIconClick={onErrorIconClick}
            onImagePreviewError={onImagePreviewError}
            onRemoveThumbnail={onRemoveThumbnail}
            displayCaption={true}
          />
        )}
      </div>
      {(isMobile && <MobileLoaderFooter {...footerProps} />) || (
        <DesktopLoaderFooter {...footerProps} />
      )}
    </div>
  );
}

LoaderFooter.propTypes = {
  files: PropTypes.array,
  onAddImages: PropTypes.func.isRequired,
  onErrorIconClick: PropTypes.func.isRequired,
  onImagePreviewError: PropTypes.func.isRequired,
  onRemoveThumbnail: PropTypes.func.isRequired,
  brokenPreviews: PropTypes.array,
  onCancelClick: PropTypes.func.isRequired,
};

export default LoaderFooter;
